import { useState } from "react";
import Header from "../common/Header";
import Footer from "../common/Footer";
import {
  WhatToReportStage,
  IncidentDateStage,
  IncidentLocationStage,
  DetailedIncidentLocationStage,
  IncidentNarrationStage,
  HasAbuserInfo,
  ReporterDetails,
  AbuserDetails,
  AbuserVehicleInfoStage,
  CaseTypeChoice,
  SubmitSuccess,
  UserViewReport,
} from "./Stages";
import { useSubmitReport } from "../hooks/useSubmitReport";
import ErrorModal from "../modals/ErrorModal";
import SupportServicesStage from "./Stages/SupportServicesStage";
// import UserReportViewCard from "../User/UserDashboard/UserReportViewCard";
// import { sampleReportPreview } from "./resources";

const ReportFlow = () => {
  const [step, setStep] = useState<number>(0);
  // const [step, setStep] = useState<number>(11);

  const { loading, error, returnedData, setError, submitReport } =
    useSubmitReport();

  const clearError = () => {
    setError(null);
  };

  const stages: Record<number, JSX.Element> = {
    0: <CaseTypeChoice setStep={setStep} />,
    1: <WhatToReportStage setStep={setStep} />,
    2: <IncidentDateStage setStep={setStep} />,
    3: <IncidentLocationStage setStep={setStep} />,
    4: <DetailedIncidentLocationStage setStep={setStep} />,
    5: <IncidentNarrationStage setStep={setStep} />,
    6: <HasAbuserInfo setStep={setStep} />,
    7: <ReporterDetails setStep={setStep} />,
    8: <AbuserDetails setStep={setStep} />,
    9: <AbuserVehicleInfoStage setStep={setStep} />,
    10: (
      <SupportServicesStage
        loading={loading}
        setStep={setStep}
        onSubmit={() => submitReport(setStep)}
      />
    ),
    11: <SubmitSuccess setStep={setStep} />,
    12: <UserViewReport report={returnedData} />,
    // 12: (
    //   <div className="max-w-[800px] mx-auto px-4 sm:px-10 mb-6">
    //     <div className="border border-gray-7 rounded-[10px]">
    //       <UserReportViewCard report={returnedData} />
    //     </div>
    //   </div>
    // ),
    // 12: <UserViewReport report={sampleReportPreview} />,
  };

  return (
    <div className="container mx-auto max-w-screen-2xl relative">
      <div className="flex flex-col h-dvh 2xl:shadow-md">
        <Header mode="light" />
        <div className="w-full flex-grow overflow-y-auto">
          {stages ? stages[step] : null}
        </div>
      </div>

      {(step === 11 || step === 12) && (
        <Footer mode={step === 11 ? "light" : "dark"} />
      )}

      {error && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-60 backdrop-blur-md z-50">
          <ErrorModal
            onAccept={clearError}
            onClose={clearError}
            errorDescription={error}
          />
        </div>
      )}
    </div>
  );
};

export default ReportFlow;
